import React, { useEffect, useState, useRef } from 'react'
import PostByAgg from '../../utils/axios';
import PostFormDataByAgg from '../../utils/axios'
import ModalAlert from '../../components/ModalAlert';
import LottieLoading from '../../components/child/LottieLoading';
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import "react-datepicker/dist/react-datepicker.css";
import DataTableLayer from "../../components/DataTableLayer";
import DocumentPreview from '../../components/DocumentPreview';
import CreateBAForm from './CreateBAForm';
import UploadBAForm from './UploadBAForm';
import HistoryModal from './HistoryBA';
import { useAuth } from '../../context/AuthContext';

const UploadBa = () => {

 const [isLoading,setIsLoading] = useState(false)
 const [data,setData] = useState([])
 const [actionMode, setActionMode] = useState('create');
 const [selectedUpload, setSelectedUpload] = useState("");
 const [modalOpen,setModalOpen] = useState(false)
 const [uploadDoc,setUploadDoc] = useState(false)
 const [selectedDate, setSelectedDate] = useState(null);
 const [file, setFile] = useState(null)
 const [openModalError, setOpenModalError] = useState(<div></div>)
 const [pagination, setPagination] = useState({
             pageIndex: 0,
             pageSize: 10,
             totalRecords: 0,
             totalPages: 0,
         });

const {musicLabelCode, roleCode} = useAuth()

 const [historyData, setHistoryData] = useState([]);
const [openHistory, setOpenHistory] = useState(false);

   const cleanUrl = (url) => {
    return url.replace(/\s+/g, '%20');  // Mengganti semua spasi dengan '%20'
  };

  const columns = [
    {
        header:"No Document",
        accessorKey:"document_no"
    },
    {
        header:"Music Label",
        accessorKey:"music_label_name"
    },
    {
        header:"Subject",
        accessorKey:"subject"
    },
    {
        header:"Description",
        accessorKey:"description"
    },
    {
          header: "Preview",
          accessorKey: "document_url",
          cell: ({ row }) => {
            const url = row.getValue("document_url");
            return url && url !== "-" ? (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-primary"
              >
                <Icon icon="mdi:eye" width={20} height={20} className="me-2" />
                View
              </a>
            ) : (
              <span>No Preview Document</span>
            );
          }
    },
    {
        header:"Document Type",
        accessorKey:"document_type_name"
    },
    {
        header:"Status",
        accessorKey:"status_name",
        cell: ({ row }) => {
            let status = row.getValue("status_name");
            // if ((roleCode === "RL2411111120977") && status === "SENT") {
            //     status = "RECEIVED";
            // }
            let badgeColor;

            switch (status.toUpperCase()) { 
            case "DRAFT":
                badgeColor = "bg-danger";
                break;
            case "SENT":
                badgeColor = "bg-primary";
                break;
            case "RECEIVED":
                badgeColor = "bg-info";
                break;
            case "RETURNED":
                badgeColor = "bg-warning";
                break;
            case "RESENT":
                badgeColor = "bg-warning";
                break;
            case "APPROVED":
                badgeColor = "bg-success";
                break;
            case "REJECTED":
                badgeColor = "bg-secondary";
                break;
            default:
                badgeColor = "bg-light";
            }

            return (
            <span className={`badge ${badgeColor}`} style={{ cursor: "pointer" }}>
                {status}
            </span>
            );
        },
    },
    {
        header: "Periode Start",
        accessorKey:"period_start"
    },
    {
        header: "Periode End",
        accessorKey:"period_end"
    },
    {
              id: 'action',
              header:"Action",
              accessorKey:"action",
              cell: ({ row }) => (
                    <div className="dropdown">
                        <button
                            className="btn px-18 py-11 text-primary-light"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <Icon
                                icon="ph:dots-three-outline-fill"
                                className="menu-icon"
                            />
                        </button>
                        <ul className="dropdown-menu"
                        >
                            <li>
                                <Link
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    to="#"
                                    onClick={() => handleAction('upload', row)}
                                >
                                    upload
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    to="#"
                                    onClick={()=> handleAction('history', row)}
                                >
                                    History
                                </Link>
                           </li>
                        </ul>
                    </div>
                ),
            }
  ]


  const ListDataBA = () => {
    setIsLoading(true);
    const url = 'label/lm/v1/document/list'

    let finalMusicLabelCode = "";

  if (roleCode === "RL2411111120977") {
  
    finalMusicLabelCode = musicLabelCode;
  } else if (
    roleCode === "RL2411062373407" || // superadmin internal
    roleCode === "RL2411065833191"    // admin internal
  ) {
    // superadmin internal & admin internal → kosong, lihat semua
    finalMusicLabelCode = "";
  }

    PostByAgg({
        url,
        body:{
            "page" : pagination.pageIndex + 1, 
            "page_size" : pagination.totalRecords,
            "keyword" : "",
            "music_label_code" : finalMusicLabelCode
        },
        onResponse: onResponseBA,
        onError:onErrorBA
    })
  }

  const onResponseBA = (res) => {
    console.log("response list BA", res.data.data)
    if(res.data.data === null || res.data.code ==="2002000"){
       setIsLoading(false)
        const listData = res.data.data.data
        const totalRecords = res.data.data.total;
        const totalPages = Math.ceil(totalRecords / pagination.pageSize);
          setPagination((prev) => ({
              ...prev,
              totalRecords: totalRecords,
              totalPages: totalPages,
              pageSize: totalRecords,
              // pageIndex: 0,
            }));
        setData(listData || [])
    }else{
        setIsLoading(false)
        setData([])
    }
  }

  const onErrorBA = (err) => {
    if(err.response.data.code === "4003400"){
        setOpenModalError(
            <ModalAlert
                show={true}
                type={"failed"}
                text={err.response.data.message.id}
                action={() => {}}
            />
        )
    }
  }

  const fetchHistory = (document_code) => {
  setIsLoading(true);
  PostByAgg({
    url: "label/lm/v1/document/list-history",
    body: {
      page: 1,
      page_size: 5,
      document_code: document_code
    },
    onResponse: (res) => {
      console.log("history response", res.data.data);
      setHistoryData(res.data.data.data || []);
      setOpenHistory(true);
      setIsLoading(false);
    },
    onError: (err) => {
      console.error("history error", err);
      setIsLoading(false);
    }
  });
};


  useEffect(()=>{
    ListDataBA()
  },[])

  const handleCreate = () => {
       setActionMode('create');
       setSelectedUpload(null);
       setModalOpen(true)
  }

  const handleAction = (action,row) => {
    console.log(`Action: ${action}, Row ID: ${row.original.id}`);
    setActionMode(action);
    setSelectedUpload(row);
    if(action === 'upload'){
        console.log("row", row.original)
        setSelectedUpload(row)
        setUploadDoc(true)
    }else if (action === 'history') {
    fetchHistory(row.original.document_code);
    }
  }

  const handleClose = () => {
    setModalOpen(false);
};
const handleCloseUpload = () => {
    setUploadDoc(false)
}


//   const handleChange = (e) => {
//     setSelectedChannel(e.target.value)
//     console.log(e.target.value)
//   }

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0]
//     setFile(selectedFile);
//     console.log("ini file",selectedFile);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     console.log("ini Mau Upload")

//   }


//    const handleDateChange = (date) => {
//     setSelectedDate(date); // update selected date
//     console.log(date);
//   };


    return (
    <>
            
             <DataTableLayer
                    data={data}
                    columns={columns}
                    title={"List Berita Acara"}
                    btnTitle={"Create"}
                    showButton={roleCode === 'RL2411111120977' ? false : true }
                    pagination={pagination}
                    onClick={handleCreate}
                  />
                  {
                    modalOpen && (
                        <CreateBAForm
                        open={modalOpen}
                        mode={actionMode}
                        upload={selectedUpload}
                        handleClose={handleClose}
                        refreshData={ListDataBA}
                        />
                    )
                  }
                {
                    uploadDoc && (
                        <UploadBAForm
                            open={uploadDoc}
                            mode={actionMode}
                            upload={selectedUpload}
                            handleClose={handleCloseUpload}
                            refreshData={ListDataBA}
                            roleCode={roleCode}
                        />
                    )
                }
                <HistoryModal
                open={openHistory}
                handleClose={() => setOpenHistory(false)}
                data={historyData}
                />
                 {isLoading && <LottieLoading text='Loading...'/>}
            {/* {showSuccessModal} */}
            
        </>
    );
  };
  
  export default UploadBa;